<template>
    <BaseDialog v-model:open="open" :title="modalHeader" width="narrow" :reserve-mobile-nav-space="false">
        <MarkdownText v-if="organizationDetails?.custom_privacy_modal_message" :text="organizationDetails.custom_privacy_modal_message" />
        <I18nT v-else keypath="onboarding.privacyNotice.body" scope="global" tag="div" class="body text-ink-muted">
            <template #privacyPolicy>
                <a class="base-link" href="https://www.valence.co/other/privacy" target="_blank" rel="noopener noreferrer">{{ t("onboarding.privacyNotice.privacyPolicyLink") }}</a>
            </template>
            <template #aiEthicsPledge>
                <a class="base-link" href="https://www.valence.co/other/ai-ethics-pledge" target="_blank" rel="noopener noreferrer">{{
                    t("onboarding.privacyNotice.aiEthicsPledgeLink")
                }}</a>
            </template>
        </I18nT>
        <template #footer>
            <BaseButton theme="primary" @click="open = false">{{ t("common.dismiss") }}</BaseButton>
        </template>
    </BaseDialog>
</template>

<script setup lang="ts">
import type { OrganizationDetails } from "~vue/appTypes";
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDialog from "~vue/components/BaseDialog.vue";
import MarkdownText from "~vue/MarkdownText.vue";
import { computed, inject, type Ref } from "vue";
import { I18nT, useI18n } from "vue-i18n";

const { t } = useI18n();

const open = defineModel<boolean>("open", { default: false });

const organizationDetails = inject<Ref<OrganizationDetails | null>>("organization_details");
const modalHeader = computed(() => organizationDetails?.value?.privacy_modal_header || t("onboarding.privacyNotice.defaultTitle"));
</script>
